module.exports = __webpack_public_path__ + "img/album.70b222fc.svg";